export default (state = {}, options: any) => {
  return {
    ...state,
    ...(options ? options : {}),
  };
};
